import { getActivity } from "@/services/activity-log.service";
import { useQuery } from "@tanstack/react-query";

export const useActivity = (id, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["activity", id],
    queryFn: () => getActivity({ id }),
    enabled: enabled && !!id,
    ...options,
  });
};
